import { useTranslation } from 'react-i18next';

interface FrameTypeSelectorProps {
  type: 'start' | 'end' | 'storyboard';
  isDisabled: boolean;
  onChange: (type: 'start' | 'end' | 'storyboard') => void;
}

export default function FrameTypeSelector({ type, isDisabled, onChange }: FrameTypeSelectorProps) {
  const { t } = useTranslation('editor');

  return (
    <div className="flex gap-2">
      <button
        onClick={() => onChange('start')}
        disabled={isDisabled}
        className={`px-4 py-2 text-sm rounded-lg transition-colors ${type === 'start'
          ? 'bg-gray-700 text-white'
          : 'text-gray-400 hover:text-gray-300 hover:bg-gray-800'
          } disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        {t('imagesTab.startFrame')}
      </button>
      <button
        onClick={() => onChange('end')}
        disabled={isDisabled}
        className={`px-4 py-2 text-sm rounded-lg transition-colors  ${type === 'end'
          ? 'bg-gray-700 text-white'
          : 'text-gray-400 hover:text-gray-300 hover:bg-gray-800'
          } disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        {t('imagesTab.endFrame')}
      </button>
      <button
        onClick={() => onChange('storyboard')}
        disabled={isDisabled}
        className={`px-4 py-2 text-sm rounded-lg transition-colors  ${type === 'storyboard'
          ? 'bg-gray-700 text-white'
          : 'text-gray-400 hover:text-gray-300 hover:bg-gray-800'
          } disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        {t('imagesTab.storyboardImage')}
      </button>
    </div>
  );
}
